export default "__VITE_ASSET__D4HiT0O5__"